/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Credentials_TitleInputs */

const es_prompt_tips_credentials_title = /** @type {(inputs: Prompt_Tips_Credentials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificá credenciales y casillas`)
};

const en_prompt_tips_credentials_title = /** @type {(inputs: Prompt_Tips_Credentials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specify credentials and mailboxes`)
};

/**
* | output |
* | --- |
* | "Specify credentials and mailboxes" |
*
* @param {Prompt_Tips_Credentials_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_credentials_title = /** @type {((inputs?: Prompt_Tips_Credentials_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Credentials_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_credentials_title(inputs)
	return en_prompt_tips_credentials_title(inputs)
});
export { prompt_tips_credentials_title as "prompt_tips.credentials_title" }